import { forwardRef } from 'react';
import MuiAppBar, { type AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

export type AppBarProps = MuiAppBarProps;

export const AppBar = forwardRef<HTMLElement, AppBarProps>(
  ({ color = 'primary', position = 'static', ...rest }, ref) => (
    <MuiAppBar ref={ref} color={color} position={position} elevation={0} {...rest} />
  )
);

AppBar.displayName = 'AppBar';
